// extracted by mini-css-extract-plugin
export default {"slider":"Footer_slider__zrCLx","slider1":"Footer_slider1__K+I7t"};